import { render, staticRenderFns } from "./IntegrationNotice.vue?vue&type=template&id=06b169a4&scoped=true"
import script from "./IntegrationNotice.vue?vue&type=script&lang=js"
export * from "./IntegrationNotice.vue?vue&type=script&lang=js"
import style0 from "./IntegrationNotice.vue?vue&type=style&index=0&id=06b169a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b169a4",
  null
  
)

export default component.exports